module.exports = __webpack_public_path__ + "img/2000_5e33d3b4e420a.df1fb3a9.png";